import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { SplitLines } from "@/components/fx/Reveal";

const FAQ = [
  { q: "Quanto tempo ci vuole?", a: "Dipende dal ruolo e dalla zona. Di solito tra 45 e 60 giorni dalla prima chiamata alla persona assunta. Nella proposta trovi i tempi precisi per il tuo caso." },
  { q: "Devo leggere i CV o fare i primi colloqui?", a: "No. Ricerca, CV, video, test e primo colloquio li gestiamo noi. Tu incontri solo una rosa ristretta di profili che hanno superato tutto, con la scheda completa in mano." },
  { q: "Lavorate con qualsiasi tipo di azienda?", a: "Sì. Industria, artigiani, negozi, ristoranti, centri estetici, studi, aziende B2B. Dall'operaio al direttore, il metodo è lo stesso." },
  { q: "Come funziona il test attitudinale?", a: "Lo costruiamo sulla tua attività, non è un quiz standard. Misura affidabilità, tenuta, attitudine al ruolo e lavoro in squadra. Il candidato lo fa online, tu trovi i risultati nella scheda." },
  { q: "Quanto costa?", a: "Una quota di avvio per brief, shooting, contenuti e campagne. Poi un compenso a risultato, solo quando firmi il contratto. Il preventivo preciso te lo facciamo dopo la prima chiamata." },
  { q: "E se la persona non funziona?", a: "C'è la garanzia 30 giorni. Se la persona se ne va nel primo mese, riprendiamo la ricerca e la sostituta non la paghi di nuovo." },
  { q: "Lavorate fuori zona?", a: "Sì, in tutta Italia. I colloqui li facciamo online, lo shooting in sede da te." },
];

export const Faq = ({ items = FAQ }) => (
  <section id="domande" className="rl-section relative py-28 lg:py-40" data-testid="faq-section">
    <div className="rl-container grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <p className="rl-eyebrow text-[#0F6E56]">Domande</p>
        <SplitLines className="rl-h2 mt-6" lines={["Domande", "frequenti."]} data-testid="faq-title" />
      </div>
      <Accordion type="single" collapsible className="lg:col-span-8" data-testid="faq-accordion">
        {items.map((f, i) => (
          <AccordionItem key={f.q} value={`f${i}`} className="border-b border-[#E7E5DF] first:border-t">
            <AccordionTrigger
              className="group py-7 text-left font-display text-xl tracking-[-0.01em] hover:no-underline sm:text-2xl [&>svg]:h-6 [&>svg]:w-6 [&>svg]:text-[#0F6E56]"
              data-testid={`faq-trigger-${i}`}
            >
              <span className="flex items-baseline gap-5 pr-4">
                <span className="font-mono-data text-[13px] text-[#6B6961]">0{i + 1}</span>
                <span className="transition-colors group-hover:text-[#0F6E56]">{f.q}</span>
              </span>
            </AccordionTrigger>
            <AccordionContent className="pb-8 pl-0 text-[16px] leading-relaxed text-[#2C2C2A]/85 sm:pl-[52px] sm:text-[17px]" data-testid={`faq-content-${i}`}>
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
